'use client'
import { FC } from 'react'
import { getVesselTitleLocalized, useSailSelect, UseSailSelectParams } from '@/root/modules/shared/SelectDateTimePage'
import { RouteInfoSection, SelectTicketButton, TripTypeToggle } from '@/root/modules/tuuleliinid/SelectDateTimePage'
import { checkIsDayDisabled } from '@/root/shared-helpers'
import { BottomSliderContainer, GoBackButton } from '@/root/components/tuuleliinid'
import { Divider } from '@/root/ui/tuuleliinid'

export const SelectDateTimeContent: FC<UseSailSelectParams> = (props) => {
  const { routeBaseInfo } = props
  const {
    locale,
    there,
    back,
    hideRoundTripButton,
    packageIdBack,
    modInvThere,
    modInvBack,
    travelThere,
    travelBack,
    startTimestampForBack,
    handleDateChange,
    handleRefIdAndTimeChange,
    setHideRoundTripButton,
    handleSwapPorts,
    packages,
    sailRefIds,
    isDisabled,
  } = useSailSelect(props)

  return (
    <div data-testid="schedule-wrapper" className="pt-10 sm:px-5 lg:px-0">
      <RouteInfoSection
        inventory={modInvThere}
        isLoading={there.loading}
        routeInfo={{
          departurePort: there.port,
          arrivalPort: back.port,
          shipName: getVesselTitleLocalized({ inventory: modInvThere, sailRefId: there.sailRefId, locale }),
          duration: travelThere,
        }}
        swapPorts={handleSwapPorts}
        hideRoundtripButton={hideRoundTripButton}
        setHideRoundTripButton={setHideRoundTripButton}
        selectedDate={there.date}
        onDayClick={handleDateChange('to')}
        isDayDisabled={checkIsDayDisabled({ availableDates: there.availableDates })}
        time={there.time || ''}
        sailRefId={there.sailRefId}
        setRefIdAndTime={handleRefIdAndTimeChange('to')}
        routeAttributes={routeBaseInfo?.routeAttributes}
        preventUndefinedPackageID={Boolean(packageIdBack)}
      />

      {/* Mobile TripTypeToggle - between sections */}
      {Boolean(packageIdBack) && (
        <div className="flex justify-center py-8 md:hidden">
          <TripTypeToggle hideRoundtripButton={hideRoundTripButton} setHideRoundTripButton={setHideRoundTripButton} />
        </div>
      )}

      {Boolean(packageIdBack) && hideRoundTripButton && (
        <>
          <div className="max-w-content mx-auto hidden px-5 py-10 md:block lg:px-0">
            <Divider />
          </div>
          <RouteInfoSection
            dataTestId="departure-back-card"
            inventory={modInvBack}
            isLoading={back.loading}
            routeInfo={{
              departurePort: back.port,
              arrivalPort: there.port,
              shipName: getVesselTitleLocalized({ inventory: modInvBack, sailRefId: back.sailRefId, locale }),
              duration: travelBack,
            }}
            swapPorts={handleSwapPorts}
            setHideRoundTripButton={setHideRoundTripButton}
            showDivider
            hideRoundtripButton
            selectedDate={back.date || there.date}
            onDayClick={handleDateChange('from')}
            isDayDisabled={checkIsDayDisabled({
              availableDates: back.availableDates,
              disableBeforeDate: there.date,
            })}
            time={back.time || ''}
            sailRefId={back.sailRefId}
            setRefIdAndTime={handleRefIdAndTimeChange('from')}
            initialTimestamp={startTimestampForBack}
            routeAttributes={routeBaseInfo?.routeAttributes}
          />
        </>
      )}

      <BottomSliderContainer>
        <GoBackButton href={`/${locale}`} />
        <SelectTicketButton
          disabled={isDisabled}
          packages={packages.filter(Boolean)}
          sailRefIds={sailRefIds.filter((id) => id >= 0)}
        />
      </BottomSliderContainer>
    </div>
  )
}
